import { useCallback, useState } from "react";
import { CustomButton } from "../CustomButton";
import RModal from "../Rsuite/Modal";
import { Container } from "rsuite";
import { CustomInput } from "../CustomInput";
import { FaStarOfLife } from "react-icons/fa";
import { schemaChangePassword } from "./schema/password.schema";
import { useAuth } from "../../hooks/auth";
import { toastSuccess, toastWarning, toastError } from '../../toasts'
import api from "../../services/api";

const ChangePassword = ({ open, onClose }) => {
  const { user } = useAuth()
  const [senhaAntiga, setSenhaAntiga] = useState();
  const [senhaNova, setSenhaNova] = useState();
  const [senhaConfirmacao, setSenhaConfirmacao] = useState();

  const handleChangePassword = useCallback(()=> {
    schemaChangePassword.validate({
      SenhaAntiga: senhaAntiga,
      SenhaNova: senhaNova,
      ConfirmacaoSenha: senhaConfirmacao
    }).then(async(validated) => {
      delete validated.ConfirmacaoSenha;
      await api.patch(`/gestor/trocarSenha/${user.Id}`, validated)
        .then(() => {
          toastSuccess('Senha alterada com sucesso');
          onClose();
      })
      .catch((error) => toastError('Não foi possivel alterar a senha: ' + error.response.data.message))
    }).catch(error => toastWarning('Preencha os campos obrigatórios: '+ error.message))
  },[onClose, senhaAntiga, senhaConfirmacao, senhaNova, user.Id])

    return(
      <RModal
        open={open}
        onClose={onClose}
        title={'Trocar senha'}
        footer={
          <>
            <CustomButton
              onClick={handleChangePassword}
              appearance="primary"
            >
              Trocar
            </CustomButton>
            <CustomButton onClick={onClose} appearance="ghost">
              Fechar
            </CustomButton>
          </>
        }
      >
        <form style={{ minWidth: 400 }}>
          <Container>
          <label htmlFor="OldPassword">Senha antiga <FaStarOfLife size={8} color="#FF0000" /></label>
          <CustomInput
              type="password"
              placeholder='Deverá conter no minimo 6 caracteres.'
              value={senhaAntiga}
              onChange={setSenhaAntiga}
            />
            <label htmlFor="NewPassword">Nova senha <FaStarOfLife size={8} color="#FF0000" /></label>
            <CustomInput
              type="password"
              placeholder='Deverá conter no minimo 6 caracteres.'
              value={senhaNova}
              onChange={setSenhaNova}
            />
            <label htmlFor="ConfirmPassword">Confirmação de senha <FaStarOfLife size={8} color="#FF0000" /></label>
            <CustomInput
              type="password"
              placeholder='Deverá conter no minimo 6 caracteres.'
              value={senhaConfirmacao}
              onChange={setSenhaConfirmacao}
            />
          </Container>
        </form>
      </RModal>
    )
}
export default ChangePassword;
